/**
 * Discriminates why the logged-in mobile upgrade paywall was reached, so the
 * post-upgrade package-picker redirect can carry the matching domain intent
 * (`add-domain-connect-intent` vs `add-domain-assign-intent`).
 */

export const isPurchaseIntent = value => value === 'purchase' || value === 'purchaseRootDomainIsRequired';
export const isSelectSiteIntent = value => isPurchaseIntent(value) || value === 'connect';
//# sourceMappingURL=types.js.map